import AttachmentsList from '@app/components/AttachmentsList'
import PageSection from '@app/components/PageSection'
import PhotoStrip from '@app/components/PhotoStrip'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { CityViewPageProps } from './CityViewPage'

export default class CityFiles extends React.PureComponent<CityViewPageProps> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.city.place.cityState} :: Files`}>
        <div className='mb-3'>
          <PageSection title='Photos'>
            <PhotoStrip photos={this.props.city.photos} />
          </PageSection>
          <PageSection title='Attachments'>
            <AttachmentsList
              attachments={this.props.city.attachments}
              onChange={this.props.setAttachments}
              className='mx-3'
            />
          </PageSection>
        </div>
      </DocumentTitle>
    )
  }
}
